import {
  createClient,
  FindOperation,
  GetOperation,
  getRequestFactory,
  getSimpleRequestFactory,
  postRequestFactory,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

import { ChargingStation, ChargingStationStatusOverview, CreateChargingStationCommand } from './model';

const client = createClient('/rest/operator-api/charging-stations');

export const chargingStationPermissions = {
  SEARCH: 'cpms.search-charging-stations',
  GET: 'cpms.get-charging-station',
  GET_OVERVIEW: 'cpms.metrics-charging-stations-statuses',
  CREATE: 'cpms.create-charging-station'
};

export const searchChargingStations: SearchOperation<ChargingStation> = searchRequestFactory<ChargingStation>(client, {
  permissionId: chargingStationPermissions.SEARCH
});
export const getChargingStation: FindOperation<ChargingStation, string> = getRequestFactory<ChargingStation, string>(
  client,
  { permissionId: chargingStationPermissions.GET }
);

export const getChargingStationOverview: GetOperation<ChargingStationStatusOverview> =
  getSimpleRequestFactory<ChargingStationStatusOverview>(client, {
    path: '/overview',
    permissionId: chargingStationPermissions.GET_OVERVIEW
  });

export const createChargingStation = postRequestFactory<CreateChargingStationCommand, void>(client, {
  pattern: '',
  permissionId: chargingStationPermissions.CREATE
});
